<template>
  <div class="newMsgIndex"> 
    <p v-if="userType == '2' " class="black-title">
      消息通知
    </p>
     <p v-else  class="black-title">
      待审核信息
    </p>
    <NOdata title="暂无消息~" v-if="this.advLists.length == 0"></NOdata>
    <div class="content" v-else>
      <div v-for="(item, index) in advLists" :key="index">
        <div class="adv-item" v-if="userType != '2'"><!--老师 -->
          <h1 class="adv-title">{{ item.dmmc }}</h1>
          <p>
            <span>{{ item.ggbt }}</span>
          </p>
          <ul>
            <li>申请人：{{ item.cjr }}</li>
            <li>创建时间：{{ item.cjsj }}</li>
          </ul>
          <div @click="goPass(item)">
            <div class="check-dtl">
              {{ item.wfexname }}
              <span style="color:red">点击审核</span>
            </div>
          </div>
        </div>
        <div v-else class="adv-item"><!--学生 -->
          <h1 class="adv-title">{{ item.content }}</h1>
            <p>
              <span>{{ item.ggbt }}</span>
            </p>
            <ul> 
              <li>创建时间：{{ item.time }}</li>
            </ul>
            <div  >
              <div class="check-dtl">
                {{ item.type }} 
              </div> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      advLists: [],
      userType: ""
    };
  },
  methods: {
    async getList() {
      if (this.userType == "2") {
        const res = await Api.getxssqjl();
        this.advLists = res.data;
      } else {
        const res = await Api.getNotShenHeMsg();
        this.advLists = res.data;
      }
    },
    goPass(item) {
      item.route = "/new/Msg1";

      // 跳转到成绩审核界面
      if (item.ywcode == "001") {
        this.$router.push({
          path: "/teacher/guideMain",
          query: {
            i_item: item
          }
        });
      } else if (item.ywcode == "002") {
      } else if (item.ywcode == "003") {
        // 新增课程审核
        this.$router.push({
          path: "/teacher/courseAuditMain",
          query: {
            id: item.key1,
            audit: item.id,
            type: 0
          }
        });
      } else if (item.ywcode == "004") {
      } else if (item.ywcode == "005") {
        // 通选课审核
        this.$router.push({
          path: "/teacher/courseAuditMain",
          query: {
            id: item.key1,
            audit: item.key2,
            type: 1
          }
        });
      } else if (item.ywcode == "006") {
        let id = {
          id: item.key2,
          sId: item.key3,
          jId: item.key1 //JX02ID
        };
        this.$router.push({
          path: "/teacher/verifyDetail",
          query: {
            id: encodeURIComponent(JSON.stringify(id)),
            i_item: item
          }
        });
      } else if (item.ywcode == "007") {
        this.$router.push({
          name: "borrowingListDetail",
          params: { route_params: encodeURI(JSON.stringify(item)) }
        });
      } else if (item.ywcode == "008") {
        // 成绩录入审核
        this.$router.push({
          path: "/teacher/examine/scoreListDetail",
          query: {
            i_item: item
          }
        });
      } else if (item.ywcode == "009") {
        // 教师调课申请
        item.kcmc = item.key1;
        item.ktmc = item.key2;
        item.tkfs = item.key3;
        item.tklx = item.key3;
        this.$router.push({
          name: "adjustListDetail",
          params: { route_params: encodeURI(JSON.stringify(item)) }
        });
      } else if (item.ywcode == "011") {
        let ids = {
          id: item.ywinstanceid,
          sId: item.id || "",
          type: 9,
          cjr: item.cjr || "",
          route: "/new/Msg1"
        };
        this.$router.push({
          path: "/teacher/bookDetail",
          query: {
            id: encodeURIComponent(JSON.stringify(ids))
          }
        });
      } else if (item.ywcode == "018") {
        let ids = {
          id: item.ywinstanceid,
          sId: item.id || "",
          type: 10,
          cjr: item.cjr || "",
          route: "/new/Msg1"
        };
        this.$router.push({
          path: "/teacher/bookDetail",
          query: {
            id: encodeURIComponent(JSON.stringify(ids))
          }
        });
      } else if (item.ywcode == "019") {
        let ids = {
          id: item.id,
          sId: item.id || "",
          type: 6,
          cjr: item.cjr || "",
          route: "/new/Msg1"
        };
        this.$router.push({
          path: "/teacher/bookDetail",
          query: {
            id: encodeURIComponent(JSON.stringify(ids))
          }
        });
      } else if (item.ywcode == "103") {
        let ids = {
          id: item.ywinstanceid,
          sId: item.id || "",
          type: 8,
          cjr: item.cjr || "",
          route: "/new/Msg1"
        };
        this.$router.push({
          path: "/teacher/bookDetail",
          query: {
            id: encodeURIComponent(JSON.stringify(ids))
          }
        });
      } else if (item.ywcode == "923") {
        let params = {
          mtid: item.ywinstanceid,
          route: "/new/Msg1",
          shlx: item.key1,
          shid: item.id
        };
        this.$router.push({
          path: "/freePass/list",
          query: {
            list: JSON.stringify(params)
          }
        });
      } else if (item.ywcode == "979") {
        // 授课数据申请审核
        let params = {
          route: "/new/Msg1",
          YWINSTANCEID: item.ywinstanceid
        };
        this.$router.push({
          path: "/sksjsqsh/detail",
          query: {
            list: params
          }
        });
      }
    }
  },
  created() {
    let list = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userType = list.userType;
    this.getList();
  }
};
</script>

<style scoped lang="less">
.newMsgIndex {
  .black-title {
    margin: -22px 20px 0;
  }
  .content {
    height: 80vh;
    overflow: auto;
    padding-top: 8px;
    padding-bottom: 80px;
  }
  .adv-item {
    margin: 0 20px 20px;
    background-color: @attendance-background-color-10;
    padding: 8px 16px;
    text-align: center;
    ul li {
      font-family: PingFangSC-Light;
      font-size: 12px;
      color: #757da3;
      letter-spacing: 0;
      margin-bottom: 1%;
    }
  }
  .adv-title {
    color: @attendance-color-1;
    font-weight: 600;
    margin-bottom: 8px;
    font-size: 16px;
  }
  .adv-item p {
    font-size: 14px;
    color: @attendance-color-2;
  }
  .adv-item .is-open {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .check-dtl {
    padding-top: 8px;
    border-top: 1px solid @attendance-border-color-2;
    margin-top: 19px;
    color: @attendance-color-2;
    font-size: 12px;
    .shzClass {
      color: #7469f8 !important;
    }
    .btgClass {
      color: #f86969 !important;
    }
    .ytgClass {
      color: #12ddd6 !important;
    }
    .dssClass {
      color: #757da3 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/Home/newMsg_10013.vue